import React from 'react';
import "./skill.css";

const Skill = ({ icon }) => {
  return (
    <div className='skill fcc'>
      {icon}
    </div>
  )
}

export default Skill